const PREFIX = "salud-v2-pending:";

function key(family, convocatoriaId) {
  let user;
  try { user = JSON.parse(localStorage.getItem("token") || "null"); } catch (_) { return null; }
  if (!Number.isSafeInteger(Number(user?.id)) || Number(user.id) < 1) return null;
  return `${PREFIX}${user.id}:${family}:${convocatoriaId}`;
}

export function readAttempt(family, convocatoriaId) {
  const name = key(family, convocatoriaId);
  if (!name) return null;
  const raw = sessionStorage.getItem(name);
  if (!raw) return null;
  let value;
  try { value = JSON.parse(raw); } catch (_) {
    throw new Error("Hay un envio pendiente que requiere revision antes de otra captura.");
  }
  if (!value?.key || !value.body || (value.body.convocatoriaId !== undefined &&
    Number(value.body.convocatoriaId) !== Number(convocatoriaId)) ||
    (value.body.familia !== undefined && value.body.familia !== family)) {
    throw new Error("Hay un envio pendiente que requiere revision antes de otra captura.");
  }
  return value;
}

export function writeAttempt(family, convocatoriaId, attempt) {
  const name = key(family, convocatoriaId);
  if (!name) throw new Error("Inicie sesion nuevamente antes de guardar.");
  try { sessionStorage.setItem(name, JSON.stringify(attempt)); } catch (_) {
    throw new Error("No se pudo conservar el intento seguro en esta pestaña. Habilite el almacenamiento y reintente sin cerrar el formulario.");
  }
}

export function clearAttempt(family, convocatoriaId) {
  const name = key(family, convocatoriaId);
  if (name) sessionStorage.removeItem(name);
}
